import script from "./EyesightDeclarationCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./EyesightDeclarationCompleted.vue?vue&type=script&setup=true&lang=js"

import "./EyesightDeclarationCompleted.vue?vue&type=style&index=0&id=29319d85&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29319d85"]])

export default __exports__